import { render, staticRenderFns } from "./RulesModal.vue?vue&type=template&id=537a9c21&scoped=true"
import script from "./RulesModal.vue?vue&type=script&lang=js"
export * from "./RulesModal.vue?vue&type=script&lang=js"
import style0 from "./RulesModal.vue?vue&type=style&index=0&id=537a9c21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a9c21",
  null
  
)

export default component.exports